import { createAction, createReducer } from 'redux-act';

import type { ILocationV2 } from '@sravni/types/lib/locations';

import { loadRegionalCenters, loadRegions } from '../services/location';

export interface IState {
  regions: {
    [gurId: number]: ILocationV2;
  };
  centers: {
    [gurId: number]: ILocationV2;
  };
  currentLocation: ILocationV2;
}

const initialState: IState = {
  regions: {},
  centers: {},
  currentLocation: {
    garId: 1405113,
    name: 'Москва',
    fullName: 'г Москва',
    nameLocative: 'в Москве',
    nameGenitive: 'Москвы',
    alias: 'moskva',
    route: '6.83.',
    routeGar: '1405113',
    localityType: 'город',
    shortLocationType: 'г',
    latitude: 55.7540471,
    longitude: 37.620405,
    fias: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
    kladr: '7700000000000',
    okato: '45000000000',
    oktmo: '45000000',
    isoCode: 'RU-MOW',
    geoNameId: '524901',
    regionCode: '77',
    regionIsoCode: 'RU-MOW',
    regionKladr: '7700000000000',
    regionGeoNameId: '524901',
    regionOkato: '45000000000',
    regionOktmo: '45000000',
    regionRoute: '6.83.',
    regionRouteGar: '1405113',
  },
};

export const setCurrentLocation = createAction<ILocationV2>('locations/set');
export const setLocations = createAction<{ regions: IState['regions']; centers: IState['centers'] }>(
  'locations/current/set',
);

const reducer = createReducer<IState>({}, initialState)
  .on(setCurrentLocation, (state, payload) => {
    return {
      ...state,
      currentLocation: payload,
    };
  })
  .on(setLocations, (state, payload) => {
    return {
      ...state,
      centers: payload.centers,
      regions: payload.regions,
    };
  });

export const fetchRegionsWithCenters = () => {
  return async (dispatch) => {
    let centers: ILocationV2[] = [];
    let regions: ILocationV2[] = [];

    try {
      [centers, regions] = await Promise.all([loadRegionalCenters(), loadRegions()]);
    } catch (e) {
      console.error(e);
    }

    dispatch(setLocations({ centers, regions }));
  };
};

export default reducer;
